<template>
  <div
    class="m-header new"
    v-if="extras.groupNavbarDisplay && extras.groupNavbarDisplay.display == 1"
    :style="{
      background:
        extras.navbarBg.colorOrBg == 'color'
          ? extras.navbarBg.color
          : 'url(' + extras.navbarBg.src + ')',
    }"
  >
    <img
      v-if="extras.headerLogo.display === 1"
      :src="extras.headerLogo.src || imgUrlObj.logo"
      alt=""
      class="logo"
    />
    <div class="info">
      <select
        v-show="showLangSwitch"
        v-model="currentLang"
        @change="onLangChange"
        class="lang-select"
      >
        <option value="zh_CN">简体中文</option>
        <option v-for="lang in langItems" :key="lang.name" :value="lang.name">
          {{ lang.displayName }}
        </option>
      </select>
      <p v-show="!isLogin && seminarInfo && seminarInfo.isOpenMember == 1">
        <span
          class="login-btn"
          @click="goto('login')"
          :style="{
            color:
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontColor
                : '',

            'font-style':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }"
        >
          {{ i18n.login }}
        </span>
        <span class="info-separate" :style="{ color: extras.login.lineStyle }"
          >|</span
        >
        <span
          class="register-btn"
          @click="goto('register')"
          :style="{
            color:
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontColor
                : '',
            'font-style':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.navbarStyle.navDefault == 'custom'
                ? extras.navbarStyle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }"
        >
          {{ i18n.register }}
        </span>
      </p>
      <img
        class="member-header"
        v-if="isLogin && seminarInfo.isOpenMember != 0"
        :src="memberInfo.headImg || imgUrlObj.wap.header"
        @click="gotoUserCenter"
      />
      <img
        class="menu-class"
        src="@/assets/images/wap/more.png"
        alt=""
        @click="ShowCLick()"
      />
    </div>
    <div
      class="nav"
      v-if="show"
      :style="{
        background:
          extras.navbarBg.colorOrBg == 'color'
            ? extras.navbarBg.color
            : 'url(' + extras.navbarBg.src + ')',
      }"
    >
      <span
        :style="{
          color:
            extras.navbarStyle.navDefault == 'custom'
              ? extras.navbarStyle.fontColor
              : '',
          'font-style':
            extras.navbarStyle.navDefault == 'custom'
              ? extras.navbarStyle.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-Weight':
            extras.navbarStyle.navDefault == 'custom'
              ? extras.navbarStyle.fontWeight == 'on'
                ? 'bolder'
                : ''
              : '',
        }"
        v-for="(item, index) in list"
        :key="index"
        v-show="extras.navText['nav' + (index + 2)] == 'show'"
        @click="
          JumpClick(
            item,
            extras.navText['linkType' + (index + 2)],
            extras.navText['anchor' + (index + 2)],
            extras.navText['link' + (index + 2)]
          )
        "
        >{{ extras.navText["text" + (index + 2)] }}</span
      >
    </div>
  </div>
</template>

<script>
import { URLS } from "fire-wind-water";
import { goto } from "../../mixins/goto";
import langManager from "../../model/lang";

var I18N = {
  zh_CN: { login: "登录", register: "注册" },
  en_US: { login: "Login", register: "Register" },
  zh_TW: { login: "登入", register: "註冊" },
};

export default {
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    loginUrl: String,
    registerUrl: String,
  },
  data() {
    return {
      i18n: I18N[langManager.current] || I18N.zh_CN,
      show: false,
      isLogin: false,
      currentLang: langManager.current,
      showLangSwitch: false,
      langItems: [],
      list: [
        {
          title: "大会简介",
          key: "introduction",
          titleKey: "introductionTitle",
        },
        {
          title: "会议日程",
          key: "meetingAgenda",
          titleKey: "meetingAgendaTitle",
        },
        {
          title: "参会嘉宾",
          key: "meetingGuest",
          titleKey: "meetingGuestTitle",
        },
        { title: "新闻资讯", key: "message", titleKey: "messageTitle" },
        { title: "合作伙伴", key: "partner", titleKey: "partnerTitle" },
        { title: "资料下载", key: "download", titleKey: "downloadTitle" },
      ],
      imgUrlObj: {
        wap: {
          logo: require("@/assets/images/logo_new.png"),
          header: require("@/assets/images/wap/my.png"),
        },
        backgroundColor: {
          value: "#135ed8",
        },
      },
    };
  },
  created() {
    const { tenantId, schemaId, memberFormId } = this.seminarInfo;
    // const { usercenterUrl } = window.config;
    this.userCenterUrl = `index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    // this.userCenterUrl = `${usercenterUrl}index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    if (URLS.getURL("isSetting") == 1) {
      this.isLogin = false;
    }
    // 根据租户多语言配置判断是否显示语言切换
    try {
      const i18n = info && info.common && info.common.i18n;
      langManager.initFromConfig(i18n);
      this.showLangSwitch = langManager.available.length > 0;
      this.langItems = langManager.available;
    } catch (e) {
      /* lang init optional */
    }
  },
  mounted() {
    let _this = this;
    document.addEventListener("click", function (e) {
      // 下面这句代码是获取 点击的区域是否包含你的菜单，如果包含，说明点击的是菜单以外，不包含则为菜单以内
      let flag = e.target.contains(
        document.getElementsByClassName("menu-class")[0]
      );
      console.log(flag);
      if (flag) {
        // eslint-disable-next-line no-self-assign
        _this.show = _this.show;
      } else {
        _this.show = false;
      }
    });
  },
  methods: {
    goto(s) {
      switch (s) {
        case "login":
          goto.login();
          break;
        case "register":
          goto.register();
          break;
      }
    },
    gotoUrl: function (url) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (url) {
        window.$sk.goto(url);
        // window.$sk.goto(url);
      }
    },
    gotoUserCenter: function () {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      // Api.getDomain(this.seminarInfo.tenantId).subscribe((res) => {
      //   if (res.result === 0) {
      //     window.location.href = `//${res.content.domain}/usercenter/${this.userCenterUrl}`;
      //   }
      // });
      window.$sk.goto(
        `${window.$sk.config.usercenterUrl}${this.userCenterUrl}`
      );
    },
    JumpClick(item, type, anchor, link) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.number = item.key;

      if (type == "anchor") {
        this.$emit("routerEvent", { key: anchor });
      } else if (type == "link") {
        window.$sk.goto(link, true).subscribe((url) => {
          window.open(url);
        });
      }
      this.show = false;
    },
    ShowCLick() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.show = !this.show;
    },
    onLangChange() {
      langManager.switch(this.currentLang);
    },
  },
};
</script>
<style scoped>
.lang-select {
  padding: 2px 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 3.2vw;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 4px center;
  background-size: 12px;
  padding-right: 20px;
  min-width: 16vw;
}
</style>
